import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HeroSection from './Components/Front page/FrontPage';
import SanskritMainContent from './Components/Content component/sanskritContent/SanskritMainContent';
import EnglishMainContent from './Components/Content component/englishContent/EnglishMainContent';
import Splitwindow from './Components/splitwindow/Splitwindow';

const App: React.FC = () => {
  return (
      <Routes>
        <Route path="/content/sanskrit" element={<SanskritMainContent />} />
        <Route path="/content/english" element={<EnglishMainContent />} />
        <Route path="/" element={<HeroSection />} />
        <Route path="/combined" element={<Splitwindow />} />
      </Routes>
  );
};

export default App;
